module.exports = __webpack_public_path__ + "img/india.ff6988b2.svg";